import { Lock } from "lucide-react";

export const TrustBanner = ({ className = "" }) => (
  <div
    data-testid="trust-banner"
    className={`flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2 shadow-sm ${className}`}
  >
    <Lock className="h-3.5 w-3.5 text-limeink" strokeWidth={2.5} />
    <p className="text-xs text-zinc-500">
      No signup. Nothing uploaded. No tracking of your answers.{" "}
      <span className="text-limeink font-semibold">Just taps.</span>
    </p>
  </div>
);
